import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { NativeNumberKeyPad } from "@coworker/app/src/components/InputPopup/NativeNumberKeyPad";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { RegexOptions } from "@coworker/app/src/components/InputPopup/shared/RegexOptions";
import React from "react";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";
import DateStampNew from "@coworker/app/src/assets/images/DateStampNew.png";
import styles from "./add-date-stamp-modal.module.css";

const DATE_STAMP_MAX_LENGTH = 6;

const validateDateStamp = (value: string) => {
  const regex =
    /^(?:\d{2}([0-4]\d|5[0-3])|(?:\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])))$/;
  return regex.test(value);
};

interface AddDateStampModalProps {
  dateStamp: string;
  onSubmit: (newDateStamp: string) => void;
  showModal: boolean;
  handleClose: () => void;
}

export const AddDateStampModal = ({
  showModal,
  handleClose,
  dateStamp,
  onSubmit,
}: AddDateStampModalProps) => {
  const { t } = useTranslation();
  const [dateStampInput, setDateStampInput] = React.useState<string>(
    dateStamp || ""
  );
  const [showError, setShowError] = React.useState(false);

  const handleSubmit = () => {
    if (validateDateStamp(dateStampInput)) {
      onSubmit(dateStampInput);
    } else {
      setShowError(true);
    }
  };

  return (
    <FixaModal visible={showModal} handleCloseBtn={handleClose}>
      <FixaSheets
        labelledById="add-date-stamp-modal-header"
        alignment="right"
        preserveAlignment={false}
        size="small"
        fullSize
        header={
          <FixaModalHeader
            id="add-date-stamp-modal-header"
            title={t("dateStampString")}
            floating={false}
          />
        }
        footer={
          <FixaModalFooter>
            <FixaButton onClick={handleSubmit} type="primary" fluid>
              {t("confirmString")}
            </FixaButton>
          </FixaModalFooter>
        }
      >
        <FixaModalBody>
          <NativeNumberKeyPad
            keypadType="number"
            inputMode="numeric"
            disabled={false}
            onComplete={handleSubmit}
            onUpdate={(updatedValue: string) => {
              setDateStampInput(updatedValue);
              setShowError(false);
            }}
            initialValue={dateStampInput}
            maxLength={DATE_STAMP_MAX_LENGTH}
            regexOptions={RegexOptions.ONLYNUMBERS}
          />
          {showError && (
            <FixaInlineMessage
              body={t("invalidDateFormatString")}
              variant="negative"
              subtle
            />
          )}
          <div className={styles["instructions-container"]}>
            <FixaInlineMessage
              dismissable
              title={t("whereCanIfindString")}
              variant="informative"
              body={
                <span className={styles["overlay"]}>
                  <FixaImage src={DateStampNew} />
                </span>
              }
            />
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
